/**
 * Section header. design.md 5.4.
 *
 * Eyebrow, heading, optional lede, optional action. Left-aligned always; the
 * eyebrow carries the red rule that is the system's single recurring brand
 * device. Every string except the eyebrow and the action label is migrated
 * content and arrives as html from the caller.
 */
import type { ReactNode } from 'react';

type Props = {
  eyebrow?: string;
  /** Heading html. */
  titleHtml?: string;
  /** The class that sizes the heading; `hp-h2` unless a blueprint overrides. */
  titleClass?: string;
  /** Heading tag, from the page-wide heading plan (9.3). */
  level?: number;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
  id?: string;
  /** Opt the header into the scroll reveal (7.4). */
  reveal?: boolean;
};

export default function SectionHeader({
  eyebrow,
  titleHtml,
  titleClass = 'hp-h2',
  level = 2,
  action,
  children,
  className,
  id,
  reveal = false,
}: Props) {
  const Tag = `h${Math.min(Math.max(level, 1), 6)}` as 'h2';
  return (
    <header
      className={['hp-section-header', 'hp-stack', action ? 'hp-section-header--with-action' : null, className]
        .filter(Boolean)
        .join(' ')}
      {...(reveal ? { 'data-reveal': '' } : null)}
    >
      {eyebrow ? <p className="hp-eyebrow">{eyebrow}</p> : null}
      {titleHtml ? (
        <Tag className={titleClass} id={id} dangerouslySetInnerHTML={{ __html: titleHtml }} />
      ) : null}
      {children}
      {action}
    </header>
  );
}
